import { gql } from 'apollo-angular';

export const saveFeedbackMutation = gql`
  mutation saveFeedback($input: ResidentFeedbackInputBean!) {
    saveFeedback(input: $input)
  }
`;

/**
 * ART-19553. A top-level scalar `Boolean!`, not an object — the facade wraps it
 * into `IResidentFeedbackEligibility` so the state slice keeps a named field.
 */
export const feedbackEligibleQuery = gql`
  query feedbackEligible {
    feedbackEligible
  }
`;
